import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MakePaymentModal from "./MakePaymentModal";
import PayStatusPopup from "../../containers/PayStatusPopup";
import Loader from "../Loader";
import { payDuePayment } from "../../utils/requestHandler";
import { toast } from "react-toastify";
import { isbookingValid } from "../../redux/booking-validation";

const MakeDuePaymentModal = ({ showPaymentModal, setShowPaymentModal }) => {
  const bookingDetails = useSelector((state) => state.bookingValidation.data);
  const [cardDetails, setCardDetails] = React.useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("");
  const dispatch = useDispatch();

  const fetchBookingValidation = () => {
    dispatch(
      isbookingValid({
        booking_id: bookingDetails.booking_id,
        last_name: bookingDetails?.guest_details[0].last_name,
      })
    );
  };

  const handleSubmitPayment = () => {
    // Clone the cardDetails state
    const clonedCardDetails = { ...cardDetails };

    // Set process_id conditionally
    clonedCardDetails.process_id =
      clonedCardDetails.card_number === "4111111111111111" &&
      clonedCardDetails.cvv_number === "123"
        ? "99"
        : "";

    setIsLoading(true);
    payDuePayment({
      order_id: bookingDetails.booking_id,
      card_details: [clonedCardDetails],
    }).then((res) => {
      setIsLoading(false);
      if (res.payment_response[0].status === "success") {
        setShowPopup(true);
        setPaymentStatus("success");
        setShowPaymentModal(false);
        fetchBookingValidation();
      } else {
        const errorMessage =
          res.payment_response[0].message || "Payment failed";
        toast.error(errorMessage);
        setShowPopup(true);
        setPaymentStatus("failure");
      }
    });
  };

  return (
    <div>
      {showPaymentModal && (
        <MakePaymentModal
          handleSubmitPayment={handleSubmitPayment}
          setShowPaymentModal={setShowPaymentModal}
          setShowPopup={setShowPopup}
          setCardDetails={setCardDetails}
        />
      )}
      {showPopup && (
        <PayStatusPopup
          onClose={() => setShowPopup(false)}
          status={paymentStatus}
        />
      )}
      {<Loader isLoading={isLoading} />}
    </div>
  );
};

export default MakeDuePaymentModal;
